<!--

@@author        j0Shi
@@date          2019.06.25
@@desc          Wrapper for Bootstrap's Bubble Element
@@usedby        ObjectVacancyFormStatus -> ObjectVavancyForm -> Object

-->

<template>
  <div
    :class="classes"
    :style="css"
  >
    <slot>This is a bubble element</slot>
  </div>
</template>

<script>
export default {
  name: 'BootstrapBubbleElement',
  props: {
    orientation: {
      type: String,
      default: 'top-left',
      required: true,
    },
    type: {
      type: String,
      default: '',
      required: false,
    },
    css: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  computed: {
    classes() {
      const classArr = ['bubble', `bubble-${this.orientation}`];
      if (this.type !== '') classArr.push(`bubble-${this.type}`);
      return classArr.join(' ');
    },
  },
};
</script>
